import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "@/components/Navbar";
import HeroSlider from "@/components/HeroSlider";
import Gallery from "@/components/Gallery";
import About from "@/components/About";
import Services from "@/components/Services";
import Projects from "@/components/Projects";
import Testimonials from "@/components/Testimonials";
import TurkeyMap from "@/components/TurkeyMap";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

// Public Pages
import KurumsalPage from "@/pages/KurumsalPage";
import MisyonPage from "@/pages/MisyonPage";
import VizyonPage from "@/pages/VizyonPage";
import IletisimPage from "@/pages/IletisimPage";
import ProjelerPage from "@/pages/ProjelerPage";
import ProjeDetayPage from "@/pages/ProjeDetayPage";
import ParselSorguPage from "@/pages/ParselSorguPage";

// Admin Pages
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProjects from "@/pages/AdminProjects";
import AdminTestimonials from "@/pages/AdminTestimonials";
import AdminMessages from "@/pages/AdminMessages";
import AdminMapPins from "@/pages/AdminMapPins";
import AdminSettings from "@/pages/AdminSettings";
import AdminSlider from "@/pages/AdminSlider";
import AdminGallery from "@/pages/AdminGallery";
import AdminAbout from "@/pages/AdminAbout";
import AdminServices from "@/pages/AdminServices";

function HomePage() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar />
      <HeroSlider />
      <Gallery />
      <About />
      <Services />
      <Projects />
      <Testimonials />
      <TurkeyMap />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function ProtectedRoute({ user, children }) {
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("bct_user");
    if (stored) {
      try { setUser(JSON.parse(stored)); } catch { /* ignore */ }
    }
    setChecking(false);
  }, []);

  if (checking) return null;

  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/" element={<HomePage />} />
        <Route path="/hakkimizda/kurumsal" element={<KurumsalPage />} />
        <Route path="/hakkimizda/misyon" element={<MisyonPage />} />
        <Route path="/hakkimizda/vizyon" element={<VizyonPage />} />
        <Route path="/projeler" element={<ProjelerPage />} />
        <Route path="/projeler/:id" element={<ProjeDetayPage />} />
        <Route path="/iletisim" element={<IletisimPage />} />
        <Route path="/parsel-sorgulama" element={<ParselSorguPage />} />

        {/* Admin */}
        <Route path="/admin/login" element={<AdminLogin onLogin={setUser} />} />
        <Route path="/admin" element={<ProtectedRoute user={user}><AdminLayout user={user} onLogout={() => setUser(null)} /></ProtectedRoute>}>
          <Route index element={<AdminDashboard />} />
          <Route path="slider" element={<AdminSlider />} />
          <Route path="gallery" element={<AdminGallery />} />
          <Route path="about" element={<AdminAbout />} />
          <Route path="services" element={<AdminServices />} />
          <Route path="projects" element={<AdminProjects />} />
          <Route path="testimonials" element={<AdminTestimonials />} />
          <Route path="messages" element={<AdminMessages />} />
          <Route path="map-pins" element={<AdminMapPins />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
